export default "__VITE_ASSET__Duw$gRo9__"